import React, { useState, useEffect } from 'react';
import axios from '../config/axios';
import '../assets/styles/ParentDashboard.css';

const EmailPreferences = () => {
    const [preferences, setPreferences] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [saveStatus, setSaveStatus] = useState('');

    useEffect(() => {
        fetchPreferences();
    }, []);

    const fetchPreferences = async () => {
        try {
            const res = await axios.get('/api/v1/email/preferences');
            setPreferences(res.data);
            setIsLoading(false);
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to load preferences');
            setIsLoading(false);
        }
    };

    const handleToggle = (key) => {
        setPreferences(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setSaveStatus('Saving...');
        try {
            const res = await axios.post('/api/v1/email/preferences', {
                weekly_digest: preferences.weekly_digest,
                chore_reminders: preferences.chore_reminders,
                goal_alerts: preferences.goal_alerts,
                streak_alerts: preferences.streak_alerts,
                digest_frequency: preferences.digest_frequency
            });
            setPreferences(res.data);
            setSaveStatus('✅ Saved successfully');
            setTimeout(() => setSaveStatus(''), 3000);
        } catch (err) {
            setSaveStatus('❌ Failed to save');
            setTimeout(() => setSaveStatus(''), 3000);
        }
    };

    if (isLoading) return <div>Loading preferences...</div>;
    if (error) return <div className="error-text" role="alert">{error}</div>;
    if (!preferences) return null;

    return (
        <div className="email-preferences card" style={{ marginTop: '20px' }}>
            <h3>📧 Notification Preferences</h3>
            <p className="card-subtitle">Control which emails you receive from DadBucks.</p>

            <form onSubmit={handleSave}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                        <input
                            type="checkbox"
                            checked={preferences.weekly_digest}
                            onChange={() => handleToggle('weekly_digest')}
                        />
                        <strong>Weekly Progress Digest</strong>
                        <span style={{ color: '#64748b', fontSize: '0.9em' }}>- Weekly updates on chores and earnings</span>
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                        <input
                            type="checkbox"
                            checked={preferences.chore_reminders}
                            onChange={() => handleToggle('chore_reminders')}
                        />
                        <strong>Chore Due Reminders</strong>
                        <span style={{ color: '#64748b', fontSize: '0.9em' }}>- Alert when chores are overdue</span>
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                        <input
                            type="checkbox"
                            checked={preferences.goal_alerts}
                            onChange={() => handleToggle('goal_alerts')}
                        />
                        <strong>Savings Goal Alerts</strong>
                        <span style={{ color: '#64748b', fontSize: '0.9em' }}>- Notifications when kids hit milestones</span>
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                        <input
                            type="checkbox"
                            checked={preferences.streak_alerts}
                            onChange={() => handleToggle('streak_alerts')}
                        />
                        <strong>Streak Alerts</strong>
                        <span style={{ color: '#64748b', fontSize: '0.9em' }}>- Updates when kids hit streak milestones</span>
                    </label>

                    <div style={{ marginTop: '10px' }}>
                        <label>
                            <strong>Digest Frequency: </strong>
                        </label>
                        <select
                            id="digest-frequency"
                            value={preferences.digest_frequency}
                            onChange={(e) => setPreferences(prev => ({ ...prev, digest_frequency: e.target.value }))}
                            aria-label="Digest frequency"
                            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #cbd5e1', marginLeft: '10px' }}
                        >
                            <option value="daily">Daily</option>
                            <option value="weekly">Weekly</option>
                            <option value="monthly">Monthly</option>
                        </select>
                    </div>
                </div>

                <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <button type="submit" className="btn-primary" aria-label="Save email preferences">Save Preferences</button>
                    {saveStatus && <span aria-live="polite" style={{ fontWeight: 600, color: saveStatus.includes('❌') ? '#ef4444' : '#10b981' }}>{saveStatus}</span>}
                </div>
            </form>
        </div>
    );
};

export default EmailPreferences;
